module.exports = __webpack_public_path__ + "static/media/text.190480cb.svg";